module.exports = __webpack_public_path__ + "img/payu.ce13571.svg";